letterAdjust.y = 5;
letterAdjust.x = 4;
letterAdjust.scale = .775;

var font_size = 24,
    panel_Hor_Adjustment = 3.5,
    font_Top_Adjustment = 12,
    tracking = 1.5,
    middleSplitAdjustment = -0.5,
    middleSpreadAdjustment   = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -268,
        horizontal: 0,
        scale_width: .2,
        scale_height: .2,
    },
    number_Adjustments = {
        top: -3,
        left: -5,
        width: 100,
        height: 80,
        middle_Space: 7,
        oneOffset: 6
    },
    colors = {
        characters: {
            athletic: [
                "#FFFFFF", // white
            ],
            academic: [
                "#231F20", // black
            ]
        },
        numbers: {
            athletic: [
                '#FFFFFF', // white
                "#231F20", // black
            ],
            academic: [
                "#5b2d82", // purple
                '#FFFFFF', // white
                "#231F20", // black
            ]
        }
    },
    outlines = {
        characters: {
            width: 1.7
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 0.5, // this moves it up from the bottom
            horizontal: 1,
            scale_width: 15.5,
            scale_height: 15.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    };
